// extracted by mini-css-extract-plugin
export default {"link":"ER1fgZ"};